/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_SuccessInputs */

const cs_public_site_demand_success = /** @type {(inputs: Public_Site_Demand_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávka odeslána`)
};

const en_public_site_demand_success = /** @type {(inputs: Public_Site_Demand_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demand sent`)
};

/**
* | output |
* | --- |
* | "Demand sent" |
*
* @param {Public_Site_Demand_SuccessInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_success = /** @type {((inputs?: Public_Site_Demand_SuccessInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_SuccessInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_success(inputs)
	return cs_public_site_demand_success(inputs)
});